import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material'
import React from 'react'

function SelectVideoman({ handleVideoman, loading, data }) {
  return (
    <FormControl fullWidth>
      <InputLabel id='videoman-select-label'>Videoman</InputLabel>
      <Select
        labelId='videoman-select-label'
        id='videoman-select'
        value={+data?.post_metas?.videoman || 0}
        label='Videoman'
        onChange={(e) => handleVideoman(data, e.target.value)}>
        <MenuItem value={0}>
          Videoman{' '}
          {loading && (
            <CircularProgress
              style={{
                width: '15px',
                height: '15px',
                marginLeft: '5px'
              }}
            />
          )}
        </MenuItem>
        {window.variables.users.map((user) => (
          <MenuItem key={user?.userId} value={+user?.userId}>
            {user?.fullName || user?.userName}
            {loading && (
              <CircularProgress
                style={{
                  width: '15px',
                  height: '15px',
                  marginLeft: '5px'
                }}
              />
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectVideoman
